module.exports = __webpack_public_path__ + "img/media-25.b84039c4.png";